// image.service.ts
import { Component, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ImageService {
  constructor(private http: HttpClient) {}

  getImagePath(id: number,type: string) {
    return this.http.get<{ backdrop_path: string }>(`${environment.backendUrl}/api/${type}/${id}`).pipe(
      map(res => {
        return res.backdrop_path
      })
    );
  }
}